package com.klantenstop.web.pages

import com.klantenstop.web.data.models.domain.Category
import com.klantenstop.web.utils.MVI

interface HomeContract : MVI<HomeContract.State, HomeContract.Intent, HomeContract.Effect> {

    data class State(
        val categories: List<Category> = emptyList(),
        val loading: Boolean = true
    )

    sealed class Intent {
        data object LoadCategories : Intent()
    }

    sealed class Effect
}
